import React from 'react'
import { FormattedMessage } from 'react-intl'

export const languageMsg = (<FormattedMessage
  id="UserPreferencesDropDown.language"
  description="The language the user can display the page in"
  defaultMessage="Language"
/>)

export const currencyMsg = (<FormattedMessage
  id="UserPreferencesDropDown.currency"
  description="The currency the user can display tickets in"
  defaultMessage="Currency"
/>)
